<template>
    <q-table
        class="app-data-table"
        flat
        dense
        row-key="id"
        :rows="rows"
        :columns="columns"
        :loading="loading"
        :aria-busy="loading"
        :pagination="{ rowsPerPage: 20 }"
        :rows-per-page-options="[10, 20, 50]"
        @row-click="onRowClick"
    >
        <template v-slot:loading>
            <q-inner-loading
                showing
                color="primary"
                label="Loading client engagements…"
                role="status"
                aria-live="polite"
            />
        </template>
        <template v-slot:body-cell-status="props">
            <q-td :props="props">
                <q-badge
                    rounded
                    outline
                    :color="statusColor(props.row.status_code)"
                    :label="props.row.statusLabel"
                />
            </q-td>
        </template>
        <template v-slot:body-cell-needs="props">
            <q-td :props="props">
                <q-badge
                    rounded
                    outline
                    :color="needsTierColor(props.row.needs_tier)"
                    :label="props.row.needsTierLabel"
                />
            </q-td>
        </template>
        <template v-slot:no-data>
            <div v-if="!loading" class="full-width row flex-center text-grey-7 q-pa-md">
                {{ noDataMessage }}
            </div>
        </template>
    </q-table>
</template>

<script>
import { needsTierColor, statusColor } from "@/services/util/tkClients";

export default {
    name: "TkEngagementTable",
    emits: ["open"],
    props: {
        rows: {
            type: Array,
            required: true,
        },
        loading: {
            type: Boolean,
            required: true,
        },
        noDataMessage: {
            type: String,
            required: true,
        },
        variant: {
            type: String,
            required: true,
            validator: value => ["my", "service"].includes(value),
        },
    },
    computed: {
        columns() {
            const commonColumns = [
                { name: "personName", label: "Client", field: "personName", align: "left", sortable: true },
                { name: "age", label: "Age", field: "age", align: "left", sortable: true },
                { name: "assignedWorker", label: "Primary Worker", field: "assignedWorkerName", align: "left", sortable: true },
            ];
            if (this.variant === "service") {
                return [
                    commonColumns[0],
                    commonColumns[1],
                    { name: "service", label: "Service", field: "service_name", align: "left", sortable: true },
                    commonColumns[2],
                    { name: "activatedAt", label: "Activation Date", field: "activatedAt", align: "left", sortable: true },
                    { name: "updatedAt", label: "Updated", field: "updatedAt", align: "left", sortable: true },
                ];
            }
            return [
                ...commonColumns,
                { name: "service", label: "Service", field: "service_name", align: "left", sortable: true },
                { name: "activatedAt", label: "Activation", field: "activatedAt", align: "left", sortable: true },
                { name: "exitedAt", label: "Exit", field: "exitedAt", align: "left", sortable: true },
                { name: "needs", label: "Needs", field: "needsTierLabel", align: "left", sortable: true },
                { name: "status", label: "Status", field: "statusLabel", align: "left", sortable: true },
                { name: "updatedAt", label: "Updated", field: "updatedAt", align: "left", sortable: true },
            ];
        },
    },
    methods: {
        needsTierColor,
        statusColor,
        onRowClick(event, row) {
            this.$emit("open", row);
        },
    },
};
</script>

<style scoped>

</style>
